import { createActionCreator } from 'utils';

const { createAction } = createActionCreator('Datasets');

export const setDatasets = createAction('Set datasets');
export const fetchDatasets = createAction(
  'Fetch datasets',
  (pageSize, pageNumber, datasetName) => ({ pageSize, pageNumber, datasetName })
);
export const createDataset = createAction('Create dataset');
export const updateDataset = createAction('Update dataset', (id, data) => ({ id, data }));
export const removeOrderFromDataset = createAction(
  'Remove order from dataset',
  (datasetId, orderId) => ({ datasetId, orderId })
);
export const updateDatasetSetEditableDataset = createAction('Update dataset set dataset to edit');
